<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="'true'"
      :title="'Forgot password'"
    />

    <main
      class="scrollable container"
      :style="{marginBottom: '30px', opacity: opacity}"
    >
      <section :style="{paddingTop: '20px', paddingBottom: '20px'}">
        <p
          class="t16"
          :style="{marginBottom: '30px'}"
        >
          Please enter your email address. You will receive a link to create a
          new password via email.
        </p>
        <Input
          :leftIcon="MailSvg"
          :rightIcon="InputCheckSvg"
          :placeholder="'Enter your email'"
          :containerStyle="{marginBottom: '30px'}"
        />
        <Button
          :title="'Send'"
          :onClick="() => $router.push('/new-password')"
        />
      </section>
    </main>
  </div>
</template>

<script setup>
// svg
import {MailSvg} from '@/assets/svg';
import {InputCheckSvg} from '@/assets/svg';

// components
import {Input} from '@/components';
import {Button} from '@/components';
import {Header} from '@/components';
import {Background} from '@/components';

// hooks
import {useOpacity} from '@/hooks';

// other
const opacity = useOpacity();
</script>
